import React from 'react';
import { Link } from 'react-router-dom';

import ImgAutocebantes from '../img/products/bombas/BombasAutocebantes.png';
import ImgCentrifugas from '../img/products/bombas/BombasCentrifugas.png';
import ImgDiafragma from '../img/products/bombas/BombasDiafragma.png';
import ImgEngranaje from '../img/products/bombas/BombasEngranaje.png';
import ImgEyectoras from '../img/products/bombas/BombasEyectoras.png';
import ImgLobulo from '../img/products/bombas/BombasLobulo.png';
import ImgMultietapas from '../img/products/bombas/BombasMultietapas.png';
import ImgSumergibles from '../img/products/bombas/BombasSumergibles.png';
import ImgTornillo from '../img/products/bombas/BombasTornillo.png';
import ImgTurbina from '../img/products/bombas/BombasTurbina.png';

const bombas = [
  { nombre: 'Bombas Autocebantes', ruta: '/BombasAutocebantes', img: ImgAutocebantes },
  { nombre: 'Bombas Centrífugas', ruta: '/BombasCentrifugas', img: ImgCentrifugas },
  { nombre: 'Bombas de Diafragma', ruta: '/BombasDiafragma', img: ImgDiafragma },
  { nombre: 'Bombas de Engranaje Interno y Externo', ruta: '/BombasEngranaje', img: ImgEngranaje },
  { nombre: 'Bombas Eyectoras', ruta: '/BombasEyectoras', img: ImgEyectoras },
  { nombre: 'Bombas de Lóbulo', ruta: '/BombasLobulo', img: ImgLobulo },
  { nombre: 'Bombas Multietapas', ruta: '/BombasMultietapas', img: ImgMultietapas },
  { nombre: 'Bombas Sumergibles para Pozo Profundo', ruta: '/BombasSumergibles', img: ImgSumergibles },
  { nombre: 'Bombas de Tornillo', ruta: '/BombasTornillo', img: ImgTornillo },
  { nombre: 'Bombas de Turbina Vertical', ruta: '/BombasTurbinaVertical', img: ImgTurbina },
];

const Bombas = () => {
  return (
    <div className="container my-5">
      <h3 className="mb-4 text-center">Diferentes Tipos de Bombas</h3>
      <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-4">
        {bombas.map((bomba, index) => (
          <div className="col" key={index}>
            <div className="card h-100 shadow-sm">
              <Link to={bomba.ruta} className="text-decoration-none text-dark">
                <img 
                  src={bomba.img} 
                  className="card-img-top bomba-img"
                  alt={bomba.nombre} 
                />
                <div className="card-body">
                  <h5 className="card-title text-center">{bomba.nombre}</h5>
                </div>
              </Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Bombas;
